import { CenoraInternalCommunication, TokenManager } from '@cenora-llc/cenora-internal-communication-library'

export default async ({ store }) => {
  // Initialize TokenManager for postMessage-based token retrieval
  // This replaces cookie-based token sharing to avoid CloudFront 8KB header limit
  TokenManager.init({
    // DEV_AUTH_TOKEN can be set in environment for standalone development
    devToken: (typeof process !== 'undefined' && process.env.DEV_AUTH_TOKEN) || null
  })

  await CenoraInternalCommunication.init(
    [
    ],
    {
      emitBasicEvents: true,
      subscribeForBasicEvents: false
    }
  )
}
